export const ResourceConfig = {
  webAngularUrl: import.meta.env.VITE_WEB_ANGULAR_URL,
  webVueUrl: import.meta.env.VITE_WEB_VUE_URL,
  webClientPortalUrl: import.meta.env.VITE_WEB_CLIENT_PORTAL_URL,
  authServer: import.meta.env.VITE_AUTH_SERVER,
  authClient: import.meta.env.VITE_AUTH_CLIENT,
  serverBase: import.meta.env.VITE_RESOURCE_SERVER_BASE,
  clientPortalServerBase: import.meta.env.VITE_RESOURCE_CLIENT_PORTAL_SERVER,
  notificationServerBase: import.meta.env.VITE_RESOURCE_NOTIFICATIONS_SERVER,
  directImportServerBase: import.meta.env.VITE_RESOURCE_DIRECT_IMPORT_SERVER_BASE,
  featureFlagCommonNotifications: import.meta.env.VITE_FEATURE_FLAG_COMMON_NOTIFICATIONS,
  reportServer: import.meta.env.VITE_RESOURCE_REPORT_SERVER,
  printPreviewServer: import.meta.env.VITE_RESOURCE_PRINT_PREVIEW_SERVER,
  cyncSiteUrl: import.meta.env.VITE_RESOURCE_CYNC_SITE_URL,
  ipGeolocationApi: import.meta.env.VITE_RESOURCE_IP_GEO_LOCATION_API,
  teamViewer: import.meta.env.VITE_RESOURCE_TEAM_VIEWER,
  caseware: import.meta.env.VITE_RESOURCE_CASEWARE,
  registrationCode: import.meta.env.VITE_RESOURCE_REGISTRATION_CODE,
  elmahApiKey: import.meta.env.VITE_RESOURCE_ELMAH_API_KEY,
  elmahLogId: import.meta.env.VITE_RESOURCE_ELMAH_LOG_ID,
  termsAndConditionsVersion: import.meta.env.VITE_RESOURCE_TERMS_AND_CONDITIONS_VERSION,
  helpBaseUrl: import.meta.env.VITE_RESOURCE_HELP_BASE_URL,
  draftworxSite: import.meta.env.VITE_RESOURCE_DRAFTWORX_SITE,
  developmentMode: import.meta.env.VITE_RESOURCE_DEVELOPMENT_MODE,
  recaptchaSiteKey: import.meta.env.VITE_RESOURCE_RECAPTCHA_SITE_KEY,
  enableCaseware: import.meta.env.VITE_RESOURCE_ENABLE_CASEWARE,
  enablePayments: import.meta.env.VITE_RESOURCE_ENABLE_PAYMENTS,
  enableRemoteSupport: import.meta.env.VITE_RESOURCE_ENABLE_REMOTE_SUPPORT,
  enableElmahLogging: import.meta.env.VITE_RESOURCE_ENABLE_ELMAH_LOGGING,
  lightThemeColor: import.meta.env.VITE_RESOURCE_LIGHT_THEME_COLOR,
  darkThemeColor: import.meta.env.VITE_RESOURCE_DARK_THEME_COLOR,
  enableAppSettings: import.meta.env.VITE_RESOURCE_ENABLE_APP_SETTINGS,
  enableDarkMode: import.meta.env.VITE_RESOURCE_ENABLE_DARK_MODE,
  enableClientPortal: import.meta.env.VITE_RESOURCE_ENABLE_CLIENT_PORTAL
};
